/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ParseClockStationFirmwareDto } from '../models/ParseClockStationFirmwareDto';
import type { ParseFirmwareRequest } from '../models/ParseFirmwareRequest';
import type { UpdateClockStationFirmwareRequest } from '../models/UpdateClockStationFirmwareRequest';
import type { UploadClockStationFirmwareRequest } from '../models/UploadClockStationFirmwareRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClockStationFirmwareService {
    /**
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public static postApiClockStationFirmwares(
        formData?: UploadClockStationFirmwareRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/clock-station-firmwares',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param page
     * @param pageSize
     * @param search
     * @returns any OK
     * @throws ApiError
     */
    public static getApiClockStationFirmwares(
        page: number = 1,
        pageSize: number = 20,
        search?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/clock-station-firmwares',
            query: {
                'Page': page,
                'PageSize': pageSize,
                'Search': search,
            },
        });
    }
    /**
     * @param formData
     * @returns ParseClockStationFirmwareDto OK
     * @throws ApiError
     */
    public static postApiClockStationFirmwaresParse(
        formData?: ParseFirmwareRequest,
    ): CancelablePromise<ParseClockStationFirmwareDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/clock-station-firmwares/parse',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiClockStationFirmwares(
        id: string,
        requestBody: UpdateClockStationFirmwareRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/clock-station-firmwares/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiClockStationFirmwares1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/clock-station-firmwares/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiClockStationFirmwares(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/clock-station-firmwares/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiClockStationFirmwaresFile(
        id: string,
        requestBody: Blob,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/clock-station-firmwares/{id}/file',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiClockStationFirmwaresFile(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/clock-station-firmwares/{id}/file',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiClockStationFirmwaresVersions(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/clock-station-firmwares/versions',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiClockStationFirmwaresHistory(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/clock-station-firmwares/{id}/history',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiClockStationFirmwaresDownload(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/clock-station-firmwares/{id}/download',
            path: {
                'id': id,
            },
        });
    }
}
